/* SEO block read more: toggles a class on the container; the rich text itself is rendered by Liquid
   so headings and paragraphs keep their spacing (30 Sep 2026). */
(function () {
  function labels() {
    var l = window.seoBlock || {};
    return { more: '+ ' + (l.readMore || 'Read more'), less: '- ' + (l.readLess || 'Read less') };
  }

  function init(root) {
    (root || document).querySelectorAll('.seo-block__description--collapsible').forEach(function (container) {
      if (container.dataset.seoInit) return;
      container.dataset.seoInit = '1';
      var button = container.querySelector('[data-read-more]');
      if (!button) return;
      var text = labels();
      button.textContent = text.more;
      button.addEventListener('click', function () {
        var collapsed = container.classList.toggle('is-collapsed');
        button.textContent = collapsed ? text.more : text.less;
        button.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        if (collapsed) container.scrollIntoView({ block: 'nearest' });
      });
    });
  }

  window.initSeoBlocks = init;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
})();
